import type { CartDto, DeliveryMethodDto } from '../../generated-api';
import { calcTotalServiceCharge } from '../utils/cart';
import { useCartStore } from '../context/cart/CartStore';
import { shallow } from 'zustand/shallow';

export const rightPrice = (vatType: string, eatInPrice: number, takeawayPrice: number | undefined) => {
  if (vatType === 'EAT_IN' || takeawayPrice === undefined) {
    return eatInPrice;
  }
  return takeawayPrice;
};

export const useTotalPrice = (): number => {
  const { vatType, totalPrice, totalTakeawayPrice } = useCartStore(
    (s) => ({
      totalPrice: s.cart.totalPrice,
      totalTakeawayPrice: s.cart.totalTakeawayPrice,
      vatType: s.cart.vatType,
    }),
    shallow
  );

  return rightPrice(vatType, totalPrice, totalTakeawayPrice);
};

export const useServiceCharge = (deliveryMethod: DeliveryMethodDto) => {
  const totalPrice = useTotalPrice();

  if (deliveryMethod.serviceChargeAmount && deliveryMethod.serviceChargeAmount > 0) {
    return calcTotalServiceCharge(totalPrice, deliveryMethod.serviceChargeAmount);
  }

  return 0;
};

export const useOriginalTotalPrice = () => {
  const { getOriginalTotalPrice, vatType } = useCartStore((x) => ({
    getOriginalTotalPrice: x.getOriginalTotalPrice,
    vatType: x.cart.vatType,
  }));

  const { totalPrice, totalTakeawayPrice } = getOriginalTotalPrice();

  return rightPrice(vatType, totalPrice, totalTakeawayPrice);
};

export const getEffectiveTotalPrice = (cart: CartDto) =>
  rightPrice(cart.vatType, cart.totalPrice, cart.totalTakeawayPrice);
